module.exports = __webpack_public_path__ + "static/media/rv.d6a0d341.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/rv.svg
// module id = 529
// module chunks = 0